import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=c4eb5fee&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4eb5fee')) {
      api.createRecord('c4eb5fee', component.options)
    } else {
      api.reload('c4eb5fee', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=c4eb5fee&", function () {
      api.rerender('c4eb5fee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2P6LHsqC8cy9Y/JS/comp/FavElement.vue"
export default component.exports